import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import pengajuanGajiProsesService from "../../services/pengajuanGajiProsesService";
import Cookies from "js-cookie";

export const initialState = {
    loading_pengajuan_gaji_proses: false,
    data_pengajuan_gaji_proses: [],
    showMessage:false,
    message:'',
}


export const getDataPengajuanGajiProses = createAsyncThunk('pengajuan_gaji_proses/data',async (data, { rejectWithValue }) => {
    try {
        const response = await pengajuanGajiProsesService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataPegawaiBelumTagihan = createAsyncThunk('pengajuan_gaji_proses/pegawai_belum_tagihan',async (data, { rejectWithValue }) => {
    try {
        const response = await pengajuanGajiProsesService.pegawai_belum_tagihan(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const hitungPajak = createAsyncThunk('pengajuan_gaji_proses/hitung_pajak',async (data, { rejectWithValue }) => {
    try {
        const response = await pengajuanGajiProsesService.hitung_pajak(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
        return rejectWithValue(err.response.data)
    }
})

export const pengajuanGajiProsesSlice = createSlice({
    name: 'pengajuan_gaji_proses',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_pengajuan_gaji_proses = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPengajuanGajiProses.fulfilled, (state, action) => {
                state.loading_pengajuan_gaji_proses = false
                state.data_pengajuan_gaji_proses = action.payload??[]
            })
            .addCase(getDataPengajuanGajiProses.pending, (state) => {
                state.loading_pengajuan_gaji_proses = true
            })
            .addCase(getDataPengajuanGajiProses.rejected, (state, action) => {
                state.loading_pengajuan_gaji_proses = false
                state.data_pengajuan_gaji_proses = action.payload
            })
    },
})

export const {
    showLoading,
} = pengajuanGajiProsesSlice.actions

export default pengajuanGajiProsesSlice.reducer
